var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVickybohoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6a499597-e99b-47dd-988c-b25a67ae5438",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.64 68.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9,25.94c2.96,0,5.51-1.73,6.71-4.24-.97,.47-2.06,.73-3.21,.73-4.11,0-7.45-3.34-7.45-7.45,0-1.15,.27-2.24,.73-3.21-2.51,1.2-4.24,3.75-4.24,6.71,0,4.11,3.34,7.45,7.45,7.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.95,53.54c.45,0,.9-.17,1.24-.51l21.98-21.98,26.37,26.37c.34,.34,.79,.51,1.24,.51s.9-.17,1.24-.51c.68-.68,.68-1.79,0-2.48l-5.33-5.33,8.04-8.04,10.59,10.59c.34,.34,.79,.51,1.24,.51s.9-.17,1.24-.51c.68-.68,.68-1.79,0-2.48l-11.83-11.83c-.68-.68-1.79-.68-2.48,0l-9.28,9.28-19.79-19.79c-.68-.68-1.79-.68-2.48,0L9.72,50.55c-.68,.68-.68,1.79,0,2.48,.34,.34,.79,.51,1.24,.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V68.08H90.64V0H0ZM3,65.08V3H87.64v62.08H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVickybohoImage);
export default __webpack_public_path__ + "static/media/vicky boho - image.e6b13ee704188194272285ffef479227.svg";
export { ForwardRef as ReactComponent };